
import "./SchedViz.css";

import { useState } from "react";

import { useSearchParams } from "react-router-dom";

import pako from "pako";

import Tabbed from "../templates/Tabbed";
import Unipage from "../templates/Unipage";

import { Chart } from "chart.js/auto";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar, Line, Scatter } from "react-chartjs-2";

Chart.register(ChartDataLabels);

function HashStr(string) {
    let hash = 0;
    for (const char of string) {
        hash = (hash << 5) - hash + char.charCodeAt(0);
        hash |= 0;
    }
    return String(hash);
};

const POS_RATES = {
    "mgr": 15,
    "ins": 14,
    "dvr": 10,
}

const RATES = {
    //"1742334137": 10,
    "1699921982": 10.24,
    //"-642623708": 10,
    //"-1599361485": 10,
    "-344753184": 10.25,
    "-1073667069": 15.35,
    //"-373187033": 10,
    "-1031574814": 10.5,
    "-594517912": 12,
    "1642930044": 10.24,
    //"-882102928": 14,
    "2051636104": 11,
    //"-875478642": 14,
    "1301389082": 0,
    //"-432772161": 10,
    "1916610335": 14.25,
    //"-773562671": 14,
    "-1582895819": 16, //old 15.25
    "-722076321": 10.35,
    "-1579723265": 15.35,
    //"1093472931": 15,
    //"-871147501": 14, 
    "874510944": 16,  
    "1092201511": 10.18,  
    //"-757833044": 10,
};

function TimeToNumber(str) {
    const parts = str.split(/:| /)

    var num = Number(parts[0])

    if (num !== 12 && parts[2] === "PM") {
        num += 12;
    }
    if (num === 12 && parts[2] === "AM") {
        num += 12
    }
    if (num <= 6 && parts[2] === "AM") {
        num += 24;
    }
    num += Number(parts[1]) / 60;

    return num;
}

function GetDateStr(dates, dayIndex) {
    const startDate = dates.split(" - ")[0];
    const dayDate = new Date(new Date(startDate).valueOf() + 86400000 * dayIndex);
    return (dayDate.getMonth() + 1) + "/" + dayDate.getDate();
}

function TimeStrToInterval(str) {
    const startStop = str.split(" - ");
    return [TimeToNumber(startStop[0]), TimeToNumber(startStop[1])];
}

const DAY_OF_WEEK = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
const DAY_OF_WEEK_COLORS = ["#f0e080", "#f0b0c0", "#80e080", "#f09050", "#50a0f0", "#9060f0", "#f05050"];
const DARK_DAY_OF_WEEK_COLORS = ["#d0a060", "#d09090", "#60a060", "#d07030", "#3070d0", "#7040d0", "#d03030"];

function GetWeeklyHoursAndCosts(data) {

    const weeklyVarCosts = {
        "mgr": [0, 0, 0, 0, 0, 0, 0],
        "ins": [0, 0, 0, 0, 0, 0, 0],
        "dvr": [0, 0, 0, 0, 0, 0, 0],
    };

    const weeklyVarHours = {
        "mgr": [0, 0, 0, 0, 0, 0, 0],
        "ins": [0, 0, 0, 0, 0, 0, 0],
        "dvr": [0, 0, 0, 0, 0, 0, 0],
    }

    const weeklyHoursByPerson = {
        "mgr": {},
        "ins": {},
        "dvr": {},
    }

    const weeklyFixedCosts = []
    const weeklyFixedHours = [0, 0, 0, 0, 0, 0, 0];

    const posKeys = ["mgr", "ins", "dvr"];

    for (var i = 0; i < posKeys.length; i++ ) {
        const posKey = posKeys[i];
        const namesAndTimes = data[posKey];

        for (const [name, sched] of Object.entries(namesAndTimes)) {
            for (var dayIndex = 0; dayIndex < 7; dayIndex++) {
                const times = sched[dayIndex];

                for (var j = 0; j < times.length; j++) {
                    const interval = TimeStrToInterval(times[j]);
                    const hours = interval[1] - interval[0];
                    const rateKey = HashStr(posKey + name);

                    if (RATES.hasOwnProperty(rateKey)) {
                        weeklyVarCosts[posKey][dayIndex] += hours * RATES[rateKey];
                    }
                    else {
                        weeklyVarCosts[posKey][dayIndex] += hours * POS_RATES[posKey];
                    }

                    if (name === "James Russell Jr" || name === "Jose Banda" || name === "Isael Casiano") {
                        weeklyFixedHours[dayIndex] += hours;
                    }
                    else {
                        weeklyVarHours[posKey][dayIndex] += hours;
                    }
                    if (!(name in weeklyHoursByPerson[posKey])) {
                        weeklyHoursByPerson[posKey][name] = [0, 0];
                    }
                    weeklyHoursByPerson[posKey][name][0] += hours;
                    weeklyHoursByPerson[posKey][name][1] += 0.25 * hours * hours;

                    if (interval[1] >= 24) {
                        weeklyHoursByPerson[posKey][name][1] += 2 + 0.5 * hours;
                    }
                    if (interval[0] == 9.5) {
                        weeklyHoursByPerson[posKey][name][1] += 1;
                    }
                    if (dayIndex == 3 || dayIndex == 6) {
                        weeklyHoursByPerson[posKey][name][1] += 0.25 * hours;
                    }
                    if (dayIndex == 4 && interval[0] == 9.5) {
                        weeklyHoursByPerson[posKey][name][1] += 2;
                    }
                    if (dayIndex == 4 || dayIndex == 5) {
                        weeklyHoursByPerson[posKey][name][1] += 0.5 * hours;
                    }
                    if (interval[0] <= 16 && 21 <= interval[1]) {
                        weeklyHoursByPerson[posKey][name][1] += (21 - 16);
                    }
                    else if (16 <= interval[0] && interval[1] <= 21) {
                        weeklyHoursByPerson[posKey][name][1] += (interval[1] - interval[0]);
                    }
                    else if (16 <= interval[0] && 21 <= interval[1]) {
                        weeklyHoursByPerson[posKey][name][1] += 21 - interval[0];
                    }
                    else if (interval[0] <= 16 && interval[1] <= 21) {
                        weeklyHoursByPerson[posKey][name][1] += interval[1] - 16;
                    }
                }

            }
        }
    }

    var jamesHours = 0;
    for (var i = 0; i < 7; i++) {
        jamesHours += weeklyFixedHours[i];
    }
    for (var i = 0; i < 7; i++) {
        weeklyFixedCosts.push(1150 * weeklyFixedHours[i] / jamesHours);
    }
    return [weeklyVarHours, weeklyFixedHours, weeklyHoursByPerson, weeklyVarCosts, weeklyFixedCosts];
}

function DaySchedule(props) {
    const namesAndTimes = props.data[props.posKey];

    const dayIndex = props.dayIndex;

    const labels = [];
    const dataSets = [];

    for (const [name, sched] of Object.entries(namesAndTimes)) {
        const times = sched[dayIndex];

        if (times.length == 0) {
            continue;
        }
        labels.push(name);

        var i = 0;
        for (i = 0; i < times.length; i++) {
            if (i == dataSets.length) {
                dataSets.push({
                    label: "Shift" + String(i + 1),
                    data: [],
                    backgroundColor: DAY_OF_WEEK_COLORS[dayIndex],
                });
            }
            while (i > 0 && dataSets[i].data.length < dataSets[i - 1].data.length - 1) {
                dataSets[i].data.push([26,26])
            }
            const interval = TimeStrToInterval(times[i]);
            dataSets[i].data.push(interval);
        }

    }

    if (labels.length == 0) {
        return (<></>);
    }

    return (<>
        <div style={{ height: (() => { return props.posKey != "ins" ? 50 + 40 * labels.length : 30 + 40 * labels.length })() }}>
            <Bar
                data={{
                    labels: labels,
                    datasets: dataSets,
                }}
                options={{
                    indexAxis: "y",
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: false,
                            position: 'top',
                        },
                        title: {
                            display: (() => { return props.posKey != "ins"; })(),
                            text: "               " + DAY_OF_WEEK[dayIndex] + " " +  GetDateStr(props.data["dts"], dayIndex),
                        },
                        datalabels: {
                            color: "#101010",
                            anchor: "center",
                            align: "center",
                            formatter: (value, context) => {

                                if (value[0] === 26 && value[1] == 26) return "";

                                var startHours = Math.floor(value[0]);
                                var startMins = Math.floor(60 * (value[0] - Math.floor(value[0])));

                                var startSuffix = "a";
                                if (startHours >= 13 && startHours <= 23) {
                                    startSuffix = "p";
                                    startHours -= 12;
                                }
                                else if (startHours == 12) {
                                    startSuffix = "p";
                                }
                                else if (startHours >= 24) {
                                    startHours -= 12;
                                }

                                var stopHours = Math.floor(value[1]);
                                var stopMins = Math.floor(60 * (value[1] - Math.floor(value[1])));

                                var stopSuffix = "a";
                                if (stopHours >= 13 && stopHours <= 23) {
                                    stopSuffix = "p";
                                    stopHours -= 12;
                                }
                                else if (stopHours > 24) {
                                    stopHours -= 24;
                                }
                                else if (stopHours == 24) {
                                    stopHours -= 12;
                                }

                                const start = String(startHours) + ":" + startMins.toLocaleString("en-US", { minimumIntegerDigits: 2 }) + startSuffix;
                                const stop = String(stopHours) + ":" + stopMins.toLocaleString("en-US", { minimumIntegerDigits: 2 }) + stopSuffix;

                                return start + " - " + stop;
                            }
                        }
                    },
                    y: {
                        stacked: true,
                    },
                    scales: {
                        x: {
                            min: 8,
                            max: 26,
                            ticks: {
                                stepSize: 1,
                                color: "#101010",
                                callback: (val, index) => {
                                    if (val > 12 && val < 24) {
                                        return (val - 12) + "p";
                                    }
                                    if (val == 12) {
                                        return "12p"
                                    }
                                    if (val == 24) {
                                        return "12a"
                                    }
                                    if (val > 24) {
                                        return (val - 24) + "a";
                                    }
                                    return val + "a";
                                },
                            },
                            grid: {
                                color: "#808080",
                            },
                        
                        },
                        y: {
                            grid: {
                                color: "#404040",
                            },
                            ticks: {
                                font: {
                                    family: "Courier New",
                                },
                                color: "#101010",
                                callback: (val, index) => {
                                    return labels[index].length > 13 ? labels[index].slice(0, 13): labels[index].padStart(13, " ");
                                },
                            }
                        }
                    }
                }}
            />
        </div>
    </>);
}

function GetCountData(data, posKeys, dayIndex) {
    const incs = [];
    const decs = [];

    for (var i = 0; i < posKeys.length; i++) {
        const namesAndTimes = data[posKeys[i]];

        for (const [name, sched] of Object.entries(namesAndTimes)) {
            const times = sched[dayIndex];

            for (var j = 0; j < times.length; j++) {
                if (times[j].length == 0) {
                    continue;
                }
                const startStop = TimeStrToInterval(times[j])

                incs.push(startStop[0]);
                decs.push(startStop[1]);
            }
        }
    }

    incs.sort((a, b) => { return a - b });
    decs.sort((a, b) => { return a - b });

    return [incs, decs];
}

function GetCountLabelsAndValues(incs, decs) {
    const labels = [8];
    const values = [0];

    var incIndex = 0;
    var decIndex = 0;

    var index = 0;

    while (incIndex < incs.length || decIndex < decs.length) {

        while (incIndex < incs.length && incs[incIndex] === labels[index]) {
            incIndex++;
            values[index]++;
        }
        while (decIndex < decs.length && decs[decIndex] === labels[index]) {
            decIndex++;
            values[index]--;
        }

        index++;

        if (incIndex < incs.length && decIndex < decs.length) {
            if (incs[incIndex] < decs[decIndex]) {
                labels.push(incs[incIndex]);
                values.push(values[index - 1] + 1);
                incIndex++;
            }
            else {
                labels.push(decs[decIndex]);
                values.push(values[index - 1] - 1);
                decIndex++;
            }
        }
        else if (incIndex < incs.length && decIndex == decs.length) {
            labels.push(incs[incIndex]);
            values.push(values[index - 1] + 1);
            incIndex++;
        }
        else if (incIndex == incs.length && decIndex < decs.length) {
            labels.push(decs[decIndex]);
            values.push(values[index - 1] - 1);
            decIndex++;
        }
    }

    labels.push(26);
    values.push(0);

    return [labels, values];
}

function DayCount(props) {

    const posKeys = props.posKeys;
    const mainPosKey = props.mainPosKey;

    const dayIndex = props.dayIndex;

    const [incs, decs] = GetCountData(props.data, posKeys, dayIndex);
    const [labels, values] = GetCountLabelsAndValues(incs, decs);

    const [mainIncs, mainDecs] = GetCountData(props.data, [mainPosKey], dayIndex);
    const [mainLabels, mainValues] = GetCountLabelsAndValues(mainIncs, mainDecs);

    var maxVal = 0;
    for (var i = 0; i < values.length; i++) {
        if (values[i] > maxVal) {
            maxVal = values[i];
        }
    }

    var index = 0;
    while (index < labels.length) {
        if (labels[index] !== mainLabels[index]) {
            mainLabels.splice(index, 0, labels[index]);
            mainValues.splice(index, 0, mainValues[index - 1]);
        }
        index++;
    }

    return (<div style={{ height: (() => { return 75 + 75 * Math.sqrt(maxVal) })() }}>
        <Scatter
            data={{
                labels: labels,
                datasets: [
                    {
                        type: "line",
                        label: props.labels[1],
                        data: mainValues,
                        stepped: true,
                        fill: true,
                        borderWidth: 1,
                        backgroundColor: DARK_DAY_OF_WEEK_COLORS[dayIndex],
                        pointStyle: false,
                    },
                    {
                        type: "line",
                        label: props.labels[0],
                        data: values,
                        stepped: true,
                        fill: true,
                        borderWidth: 1,
                        backgroundColor: DAY_OF_WEEK_COLORS[dayIndex],
                        pointStyle: false,
                    },
 
                ]
            }}
            options={{
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: "x",
                plugins: {
                    datalabels: {
                        display: false,
                    },
                    title: {
                        display: true,
                        text: DAY_OF_WEEK[dayIndex] + " " + GetDateStr(props.data["dts"], dayIndex),
                    },
                    legend: {
                        display: true,
                        position: 'top',
                    },
                },
                scales: {
                    x: {
                        min: 8,
                        max: 26,
                        ticks: {
                            stepSize: 1,
                            color: "#101010",
                            callback: (val, index) => {
                                if (val > 12 && val < 24) {
                                    return (val - 12) + "p";
                                }
                                if (val == 12) {
                                    return "12p"
                                }
                                if (val == 24) {
                                    return "12a"
                                }
                                if (val > 24) {
                                    return (val - 24) + "a";
                                }
                                return val + "a";
                            }
                        },
                        grid: {
                            color: "#808080",
                        },
                    },
                    y: {
                        min: 0,
                        max: maxVal + 1,
                        ticks: {
                            stepSize: 1,
                            color: "#101010",
                        },
                        grid: {
                            color: "#404040",
                        },
                    }
                }
            }}
        />
    </div>);
}

function WeeklySummary(props) {
    const [varHours, fixedHours, staffHours, varCosts, fixedCosts] = GetWeeklyHoursAndCosts(props.data);

    const totalMgrCosts = [];
    const totalMgrHours = [];
    const totalInsCosts = varCosts["ins"];
    const totalInsHours = varHours["ins"];
    const totalDvrCosts = varCosts["dvr"];
    const totalDvrHours = varHours["dvr"];

    const totalCosts = []
    const totalHours = [];

    var totalCost = 0;
    var totalMgrTime = 0;
    var totalInsTime = 0;
    var totalDvrTime = 0;
    var totalTime = 0;

    for (var i = 0; i < 7; i++) {
        totalMgrCosts.push(varCosts["mgr"][i]);
        totalMgrCosts[i] += fixedCosts[i];

        totalMgrHours.push(varHours["mgr"][i]);
        totalMgrHours[i] += fixedHours[i];

        totalCosts.push(totalMgrCosts[i] + totalDvrCosts[i] + totalInsCosts[i]);
        totalCost += totalCosts[i];

        totalHours.push(totalMgrHours[i] + totalDvrHours[i] + totalInsHours[i]);
        totalTime += totalHours[i];
        totalMgrTime += totalMgrHours[i];
        totalDvrTime += totalDvrHours[i];
        totalInsTime += totalInsHours[i];
    }

    const mgrHoursByPerson = staffHours["mgr"];
    const insHoursByPerson = staffHours["ins"];
    const dvrHoursByPerson = staffHours["dvr"];

    const mgrLabels = [];
    const insLabels = [];
    const dvrLabels = [];

    const mgrHours = [];
    const insHours = [];
    const dvrHours = [];



    const dictDataSets = [
        [mgrHoursByPerson, mgrLabels, mgrHours],
        [insHoursByPerson, insLabels, insHours],
        [dvrHoursByPerson, dvrLabels, dvrHours],
    ];

    var allNames = [];

    var owData = {};

    for (var i = 0; i < dictDataSets.length; i++) {
        const [src, labels, data] = dictDataSets[i];

        for (const [name, hoursOW] of Object.entries(src)) {
            const hours = hoursOW[0];
            const ow = hoursOW[1];
            var pos = 0;
            while (data.length == pos || hours < data[pos]) {
                pos++;
            }

            labels.splice(pos, 0, name);
            data.splice(pos, 0, hours);

            if (name in owData) {
                owData[name] += hoursOW[1];
            }
            else {
                owData[name] = hoursOW[1];
            }

        }
        allNames = [...allNames, ...labels];

    }
    const padInsHours = [...Array(mgrHours.length), ...insHours];
    const padDvrHours = [...Array(mgrHours.length + insHours.length), ...dvrHours];

    const sortedOW = Object.entries(owData).sort((a, b) => { return b[1] - a[1]; });

    return (<>
        <h5>Weekly Hours</h5>
        <p>Total: {Math.round(totalTime)} hours</p>
        <div style={{ height: 450 }} >
            <Bar
                data={{
                    labels: DAY_OF_WEEK,
                    datasets: [
                        {
                            label: "Managers",
                            type: "line",
                            data: totalMgrHours,
                            backgroundColor: "#f070b0",
                            borderColor: "#f070b0",
                            datalabels: {
                                anchor: "center",
                                align: "right",
                                offset: 8,
                            }
                        },
                        {
                            label: "CSRs",
                            type: "line",
                            data: totalInsHours,
                            backgroundColor: "#70f0b0",
                            borderColor: "#70f0b0",
                            datalabels: {
                                align: "bottom",
                            }

                        },
                        {
                            label: "Drivers",
                            type: "line",
                            data: totalDvrHours,
                            backgroundColor: "#f0b070",
                            borderColor: "#f0b070",
                            datalabels: {
                                anchor: "center",
                                align: "left",
                                offset: 8,
                            }
                        },
                        {
                            label: "Total",
                            data: totalHours,
                            backgroundColor: "#70b0f0",
                        },
                    ]
                }}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top',
                        },
                        title: {
                            display: false,
                        },
                        datalabels: {
                            color: "#101010",
                            anchor: "end",
                            align: "top",
                            offset: 2,
                            formatter: (value, context) => { return Math.round(value) + " hr."; }
                        }
                    },
                    y: {
                        stacked: false,
                    },
                    x: {
                        stacked: false,
                    },
                    scales: {
                        x: {
                            ticks: {
                                color: "#101010",
                            },
                            grid: {
                                color: "#808080",
                            },
                        },
                        y: {
                            min: 0,
                            grid: {
                                color: "#404040",
                            },
                            ticks: {
                                color: "#101010",
                                stepSize: 25,
                            }
                        }
                    }

                }}
            />
        </div>
        <h5>Weekly Costs</h5>
        <p>Total: ${Math.round(totalCost)}</p>
        <div style={{ height: 450 }} >
            <Bar
                data={{
                    labels: DAY_OF_WEEK,
                    datasets: [
                        {
                            label: "Managers",
                            type: "line",
                            data: totalMgrCosts,
                            backgroundColor: "#f070b0",
                            borderColor: "#f070b0",
                            datalabels: {
                                anchor: "center",
                                align: "right",
                            }
                        },
                        {
                            label: "CSRs",
                            type: "line",
                            data: totalInsCosts,
                            backgroundColor: "#70f0b0",
                            borderColor: "#70f0b0",
                            datalabels: {
                                align: "bottom",
                            }

                        },
                        {
                            label: "Drivers",
                            type: "line",
                            data: totalDvrCosts,
                            backgroundColor: "#f0b070",
                            borderColor: "#f0b070",
                            datalabels: {
                                anchor: "center",
                                align: "left",
                            }
                        },
                        {
                            label: "Total",
                            data: totalCosts,
                            backgroundColor: "#70b0f0",
                        },
                    ]
                }}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top',
                        },
                        title: {
                            display: false,
                        },
                        datalabels: {
                            color: "#101010",
                            anchor: "end",
                            align: "top",
                            offset: 2,
                            formatter: (value, context) => { return "$" + Math.round(value); }
                        }
                    },
                    y: {
                        stacked: false,
                    },
                    x: {
                        stacked: false,
                    },
                    scales: {
                        x: {
                            ticks: {
                                color: "#101010",
                            },
                            grid: {
                                color: "#808080",
                            },
                        },
                        y: {
                            min: 0,
                            grid: {
                                color: "#404040",
                            },
                            ticks: {
                                color: "#101010",
                                stepSize: 250,
                            }
                        }
                    }

                }}
            />
        </div>
        <h5>Employee Hours</h5>
        <p>Totals -
            <ul>
                <li>Manager: {Math.round(totalMgrTime)} hours</li>
                <li>CSR: {Math.round(totalInsTime)} hours</li>
                <li>Driver: {Math.round(totalDvrTime)} hours</li>
            </ul>
        </p>
        <div style={{ height: 50 + 25 * allNames.length }} >
            <Bar
                data={{
                    labels: allNames,
                    datasets: [
                        {
                            label: "Manager",
                            data: mgrHours,
                            backgroundColor: "#f070b0",
                        },
                        {
                            label: "CSR",
                            data: padInsHours,
                            backgroundColor: "#70f0b0",
                        },
                        {
                            label: "Driver",
                            data: padDvrHours,
                            backgroundColor: "#f0b070",
                        },
                    ],
                }}
                options={{
                    indexAxis: (() => {
                        if (window.innerWidth > window.innerHeight) {
                            return "x";
                        }
                        else {
                            return "y";
                        }
                    })(),
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'top',
                        },
                        title: {
                            display: false,
                        },
                        datalabels: {
                            color: "#101010",
                            anchor: "end",
                            align: (() => {
                                if (window.innerWidth > window.innerHeight) {
                                    return "top";
                                }
                                else {
                                    return "right";
                                }
                            })(),
                            offset: 2,
                            formatter: (value, context) => {
                                if (value === undefined) {
                                    return "";
                                }
                                return value + " hr.";
                            }
                        }
                    },
                    y: {
                        stacked: false,
                    },
                    x: {
                        stacked: false,
                    },
                    scales: {
                        x: {
                            ticks: {
                                color: "#101010",
                                stepSize: 5,
                            },
                            grid: {

                                color: (() => {
                                    if (window.innerWidth > window.innerHeight) {
                                        return "";
                                    }
                                    else {
                                        return "#404040";
                                    }
                                })(),
                            },
                        },
                        y: {
                            min: 0,
                            grid: {
                                color: (() => {
                                    if (window.innerWidth > window.innerHeight) {
                                        return "#404040";
                                    }
                                    else {
                                        return "";
                                    }
                                })(),
                            },
                            ticks: {
                                font: {
                                    family: "Courier New",
                                },
                                color: "#101010",
                                callback: (val, index) => {
                                    if (window.innerWidth > window.innerHeight) {
                                        return val;
                                    }
                                    return allNames[index].length > 13 ? allNames[index].slice(0, 13) : allNames[index].padStart(13, " ");

                                },

                            }
                        }
                    }

                }}
            />
        </div>
        <h5>Overworked & Underworked</h5>
        <p>
            <table className="mx-3 my-1" style={{ display: "inline-block" }}>
                <tr><th colspan="3">Top 5 Overworked</th></tr>
                {
                    sortedOW.map((value, index) => {
                        if (index >= 5) {
                            return "";
                        }
                        return (
                            <tr>
                                <td>{index + 1}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{value[0]}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td style={{ textAlign: "center" }}>{10 * Math.round(value[1] / 10)}</td>

                            </tr>
                        );
                    })
                }
            </table>
            <table className="mx-3 my-1" style={{ display: "inline-block" }}>
                <tr><th colspan="3">Top 5 Underworked</th></tr>
                {
                    sortedOW.map((value, index) => {
                        if (index >= 5) {
                            return "";
                        }
                        return (
                            <tr>
                                <td>{sortedOW.length - (4 - index)}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td>{sortedOW[sortedOW.length - 1 - (4 - index)][0]}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td style={{ textAlign: "center" }}>{10 * Math.round(sortedOW[sortedOW.length - 1 - (4 - index)][1] / 10)}</td>

                            </tr>
                        );
                    })
                }
            </table>
        </p>

        <p>*For off-peak hours, a score of 80 is equivalent to working five 8-hour shifts, while a score of 20 is roughly equivalent to working two 6-hour shifts.</p>
    </>);
}

export default function SchedViz() {

    const [searchParams, setSearchParams] = useSearchParams();

    const data = searchParams.get("data");

    var mgmtFlag = false;

    try {
        mgmtFlag = (searchParams.get("mgmt") == "true");
        
    }
    catch {
        mgmtFlag = false;
    }
    mgmtFlag = true; // override

    const dataArr = Uint8Array.fromBase64(data, { alphabet: "base64url" });

    const str = pako.ungzip(dataArr, { to: "string" });

    const obj = JSON.parse(str);

    const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    const tabNames = daysOfWeek;
    if (mgmtFlag === true) {
        tabNames.push("Summary")
    }

    const tabContent = [0, 1, 2, 3, 4, 5, 6].map((index) => (
        <div key={index}>
            {
                (index == 5) ?

                    <><h4>Orders</h4><p>Opening puts up truck.</p></> : <></>
            }
            {
                (index == 1 || index == 3) ?
                    <><h4>Orders</h4><p>Opening puts up truck. Closing orders next truck.</p></> : <></>
            }
            {
                (index == 6) ?
                    <><h4>Orders</h4><p>Closing orders next truck (supply and soda).</p></> : <></>
            }
            <h4>Insiders</h4>
            <DaySchedule data={obj} posKey="mgr" dayIndex={index} />
            <DaySchedule data={obj} posKey="ins" dayIndex={index} />
            <h4>Drivers</h4>
            <DaySchedule data={obj} posKey="dvr" dayIndex={index} />
            <h4>Managers vs. All Insiders</h4>
            <DayCount data={obj} posKeys={["mgr", "ins"]} mainPosKey={"mgr"} labels={["All Insiders", "Mangers"]} dayIndex={index} />
            <h4>Drivers vs. All Staff</h4>
            <DayCount data={obj} posKeys={["mgr", "ins", "dvr"]} mainPosKey={"dvr"} labels={["All Staff", "Drivers"]} dayIndex={index} />
        </div>
    ));

    if (mgmtFlag === true) {
        tabContent.push(
            <div key={7}>
                <h4>Labor Summary</h4>
                <WeeklySummary data={obj} />
            </div>
        );
    }

    return <Unipage
        hideNav={true}
        content={
            <>
                {/* str */}
                <h2>Weekly Schedule</h2>
                <p>
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_61U3WvCMBD_V448d9jvzb7pugnbHEOHL-JDsMGF1QTSVqbi_76kxTa1qUMY5OG4u_zud59HlOQZilA4cAau7YZwB-HgvhSRhZKdQNERjcQWs4TDrKAHFC2XK0s9FES2DR9T-WVYSehGrXorC42KLKcMYoG_iYLXnB0ljS4hNK0yhJFncA9rd7ft7ndxJIkxwbmgPzDGIueXLOzID5pM6mhOJaIK1QlM7Jo0JwKzHD4xY0SUASSspzzln0ArlVTbXXXH4gRmi2-GCs9qyeQVJ4TBJOW7iklNU2bhB3XODY6nl6JFyWvStrUIc87YHt7p-ounmTYyJkJ_WBTcAqdEUAxzmu5wtzmmMft3dUnlZKHtptyJR8z2nMGUc0b2WoZDY09v0Z6Dtie3Z2xjSjYcYgJvGJ4LwnICC5LibF3NsOGTGapvv6SvYbmuVElyeuEZkXvEkqpVN-Te2VC9AN0fVl-tDOCqdZRlqnVPKcUHLGDGE0E3BSlvGnJrpPBit5y-rWt4PmgHoroWnYS9rrOs1RTnOSUQ8y1lNRXtoLnGBpkva2uIzZt8rXGn0y_opQ4uDQYAAA==">Jun 1</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VUTU_DMAz9K5bPRbTbOthuY-NDMBACxAXtYK3RiOgSKe0mxsR_J_1Kky7ThNRD-mI_28929pjkGY4xPu_pL-wN4Qzi835UnjHAZKtwvMd3SpniBK883RKOPz4wHochPD9q8yisjrgI_gvrn34IkwIftHD9LQKcbLKcC5gp-mLdqMVpYtnjsODq3mm08eg5Hjg4pNIRrxjlin_DFalcHhY6iNuK_NFKi4P8bBY3jyLorSKRwxsJwVQZ09Il7uqCUU1dXkYmIQuOajjAvgk7tGU3WQ79zTCwTu6BEibgNpXbKrmOaa1Dq6oRwG70oMpIw6PTU-HjKIZBrUkkEl42_KdOxCXxU59E6ya8SiF28MSXnzLNLH6fLCduStk-SaxgzlqmtoM9b92F15NkKUylSmS1Zl1PR3gzjIvFb4DrVbmp9zJjenpFUq3pyNgfLoxnAxyNrEG1ePxobDVqSmInBTxKKdiuGRlvsCMcR9FGrk4a_lWecbaSMGMwJ7jZMJEzeGcpZUvZ5DTy9c8J3Ursad6oGX0d7J6v1zu4I_HFhT09x8puBkU3rnTY43XK6YcUvMhE8dWGlTOuozXPzKW7aM4r4N4YlwtnqUJD1L5i7ftwYTVwzmROMOOZ2fgug5_3BFoV_PsHGi2SNXMGAAA=">May 25</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_6VVTW_bMAz9K4TOKeLvpb6l9dahTYqhLXoJchBqwRXmSIBsB2uK_PfJdmtTiZQMK-CDTUqPj-Qj_U7yuiIpiaf-bBp4QQIXEE-DqHsnE7IpFEnfyVwICndcFCRdrchlGnowX7ZHU8-DX0uynqz043b4Qf-tPTPDs15PSMZZISFjsKDwo2GiZvDMSlq9yC5aPFz127f5AGp1OI9_BFtqZPEGP5kSVORs14Y4Rd24fK2vSgFLKQV7-7zp5GeFRNYEWX1_QAlOJ6Np3NINq-ChqSpWlnCrPpkELXR3-tIsP4LxUNDYGnMkaLcOtNf7Ccm3vT6aquYCMkV_s3NNCy1NS6ytTGz8HCC6LM-0ZIpTeOTllnYs-mw71hHKOzlXjv83uzya3t0rFQUs-vqE4xnfojcSDX7USmT1cW_CsRw-DkhzJuCmlFvWSQRf9wzUcDSHg3kc2W_ocIg0Fh7w1jFvFBU1PFEh2CBL1IXErBTy4BHxfdsFB44JEg7ZXzFaK_4Hrqiq5clZNYodxYhf5OySDvAohV4k9_zlVZbVR4ADPpEz3egIbq42eiFJPdZ8N6KZpLEWrNZ_2qgOoeEUXZlr7HvJSriWKpf9kB2sSdeqb5cFF1W7LL6XnO6oggeZK140_Q5GE3EkrFYQ1qXpIXNok4-p3KOC6XQWTNYUMl4NejXTnxlk0Kyc70X7t6F1zRlkcqP_nQ3bfbX8-_1fdbBNZrEHAAA=">May 18</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_61VTW_iMBD9KyOfs2q-oEtutNmtVKBatVUvFYdRY1FrjS05AS1U_PeNE2Q7TZzdqpU4mDd43sybN-aNFFVJMjK5iKKLOIyn8A3q82VzJgHZbhTJ3shcCIQFExuSPT-TWZaEMF_pn2ZhCL9WZB18BRrF7ZcavrSw_qwDkjO6kZBTWCL83FFRUXiiHMsX2dQ0MVcjfZq3GT-NWv5rFAcpYCWloAdNaaP-hkKTMx5nqglucUtLuN-VJeUcblWPYzKYzDIPo1N90vWsTwFhotTjXGFVMQq53NYj3dHjewVDp4dheDyS2kjkROomf3CGR1RwLwvFDHXU1tjMPXHnrjU8a9Q1hZbWduiBTSoSG4KZkSMgSyorhJyV1BGbJKb4WbcrG_jupE5MagdtxC72ze5cUawU-wNXqKoxr6b9Go0IHkFbTW8UigoeUYi2j4_snHXpeyn7QXOt5pzvUTGsSQ9cqnH7-LvyGqhh2JUVE5Ar_E3P0_mCJZ8O7ZB_JxevKDawNAV0XijrAf94WgMnxsD2zhBcMz5IIQ5wx15eJS8dVzpzSL3jS_sqqi2KQtbPCjs62Wy3s86s_hs9p7-TlMO1VIXco1us21votjy4yoPwmeEJOdVOe2C8QzG4LV1HJR6VEt8Fa-8FFlTADZd72n-H03_I5Hs-I4dg_N_MpRt7T0-nv2Mzp5jABwAA">May 11</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VVwWrjMBD9lUHnLLEdO018S2u20Mal7C57KTkMtUjFKiOwnLBpyb-vZLu2YsuwBR_E08ybeW9G-IMVlWYpS-bxPAqiJXyDZB4G9ZnN2GFfsvSDbYgQHgXtWfrywtbpIoBNbkPt6Tlnu5mLRl40TINPtP92M3aHdFYEuVLEzzV_3ESanFXP1HwO39JbxUXDoCOK7GmTG0VOQ2EL2thlF9qhprcHPHANP45acynhoazbS8ahhiAa1apbcGLD5BP1MyR-hjZkAHsU7y4zVpzqed1yrErxF26xrNR0072ti-56fW25MeG-RKrgFxLxxoDG13YBgoHdQ3hws3QTwk7EzVVVL5Xp5BELTnAv1antpDfdITD7Eyet1sC6_jxyPRjuVSt1c8JSoNF6lmo0bG9Sn3rUlSDISvzDbeb0nNuBDdCbiVjPTkxQW4PekPaw7RoInbH-h--9mp-K6AxP4vVNSd2yDQYTT8449i-Fm2ANKw9IhTKvS7w7FRJvy19AW_pM8L2CjMMW4fuRU8XhN5eoX1VfrN__2MtkaJ4Ul3CnykKd0JNYS4y6ga7ctyhI27e4FVIKpME2uTL6_LVnHOZtLjwr6MBdlul3y1WFkAndvJCRvJVTN3YYrrYjGG-HVenhsCVzrCrBIVMH84M48vcv-Hu5_AMhBGgigAYAAA==">May 4</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_41VUW-bMBD-K5afU4UAoYE3mkqd2tJNa9SXKA-nYSXeHFsybras6n-fDQUOZtpKeUB3vrvvvu-z80JLU9GMxvPwch4GYUIuyHIe1Z90Ro97TbMXmksJ5I7LPc22W5pmUUDywp3MgoB8K-hutm1-NGkiNrcI-iRdhF18hcLeTr7obkbXIM9KkkIpyc41jmU_y33lLY7phH9ei9SGw_68r4uFcQtHVpHvz1XFhCC32iFxp-OpmaGbOU6gKB4Ze4FEXTRtqmogBROWEfKFaQmyZH9bIJ_mdBCNxkrudq8zWp5q-W80SEM2ICXTIwckH85A0ict_M4uuCQaCTLsbzfOnyvDJbnW8IvVMBIf5_7opC3Q8fDD4xbEHZRMkhuhTm9coGMB2iH2hhs5oz4TeArSbLFENNmhTyCY5kAeuThBPbVvkqIe2ClYT7pYdIwipenSC-VtaK6P1ljKep235hrSkv7nmabwioHR_A-5Am2Ut3IkzICRaATjUUlr8wf-46BEhbr11omHu04lXLMHxQRZK12qhke_E5F5e94uUTjE4r4fdkSewIm3gbNQejj1PTKd2Q4g9-SeDYp6SVvEK-Q7bIz2sbA3mcvK3eSN0px8lSDgJ4yvUOCTs4NSgDEH9pusNTfGPn3tc4M3iLz1tvieKQPkmlcM7Y-groY3pHFBPnoyJv5E7Hqv_wDTkPMrxgYAAA==">Apr 27</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VUXU_CMBT9Kzd9xrgPmLK3CdFERY0aXwgPN67BammTtqBo-O92cxsdKxiSPnTn3p17enpvf0huNElJ_zQK7IoSOAG7T8o96ZHFXJH0h2RCINwwMSfpdEqGaRxANrGpgzQI4GFCZr2pXU4gbgfCsPguI2fbiJMfetGGftYjY0bnEsYUbhEul1QYCi-Uo36VpaYqtabKmtL7AtWyzCMUaylgIqWg64JsjwiLRg3Z8LDgvWgYNBSRo8fKuMYF1fC41JpyDteqVnLcyUi_KLvLT8LIC2-TG4rZpkeY0MWtT9CYN_oJI8WMsaJKo_teCxyioHX1Xa2B60bYmNR37vqWSoMwZprWLhTJcVPj_G93oHLhs78XC_5nqRjcC-T4jtsCnTJDp4yj9Oyf6oWD-aqcmyuFwsAzCvF3kqNaxUXjtqX-WNVcJZw4dmZLbZiAscIPenhYEm9L-Rst8TayP92KuMGcCrjiclVZ0WoJ11Ef3L6Y1k27DRkOanSwTQ4dGivkBTlVDOGJ8RUeaOnYiybeRt6pGHQ67oKiUewLLlAZ-d9kdw4b77BlaoEil_axYN_OgAy8io9AK_o7STmMpMrlClvzV__iTsCeZ87_4Ede97yw1fEkhVjDHXt9k1x35nTYfTqqE2w2v-qw8CDXBgAA">Apr 20</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VVW2-bMBT-K0d-zlQggRbe0qB1akI3rVVfojxYxUq8EVsyTra2yn-fuRlDDGhSHsi5fOf2neNPlMocRWhx485vPMcL4Auo77D8RjN03AsUfaIlYxjWlO1RtN2iMJo7sEyUqR85DvxI0G62VT9DMe8qXLf4X2puh1w01m6GHvGR5PDzlOcky-BR1GEbjAYOldhe5ajkQYuNWmloSAcw2izuOsaN1HUmMFTOMSV7DjGBDYavJ8IkgVeS4fyNl9n7Oh8zsF-E6Esrhc080FKvY17ET1Qw9g7fiGCYpeSjiNqrYrL1FViFt1JonEHCOSPvNdhgZs2cHVuCNpfdZYYoywtyJVjKA_kDK0GlVPMu27XQjTHH10rNidTBPa0Mqi_NPgtDVIEbwiWGmOZEGOUttO2dNXA4gt1qinmosiiBmB_V3pz0PNp8rcM0emWOWOG9cEHhO8MZ_oWvsOaTWY_WUkwjPZerfk-wFPQv3GMhx5lr2a-rbLrdKsp4EJhJeMGMVW2vOdPn4YC4PiYNcfuDbn2CCSiVySvOiKAYnml2xj3SdRZ-kHUm8sJwMDrWo6kKu8YpYfCQ8XPdAH-IW74ZV2sM3rjuZFAz-QFr1-jJ8pRLyiAW-DdpDsjQKbJcLnT7X2fLehhm6Jkzdcie6NuBZ7mxmvZuj2rKmsRRHUSunhP6Yb1jobUvk9Ia_omTDFZcpPxs7KXaActUjesSRq6vCdo-j8HVwoy_K-YVGD0f6wNme9gQi9PQC727XP4BZ-uJSyAIAAA=">Apr 13</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_51VTW_iMBD9KyOfs4J8AIUbBbWrlnRX26oXxGFELHAbbMkx7HYr_vs6IR82cUq7Ug7JzPh53sybyTtJVEYmJOoNe0E_GMI3iHp-ULwTj-w2kkzeyZRzhHvGN2SyXJLBpN-Hn7EO9fO3aUxW3lI_ZDwJ80_tCE8hlcMvA7Vn1HiM-KHTWqOsPHKHO5rBr32W0TSFO1lk0oQOrAutRx-OaYr8Db5TyZEn9G9-2L7KtxP-CFjjzTSa4BALwelbBaZJhjXJsKYTnN61ddxYu9n7_bq6QVNdErZrrvOYM7oRMKewQLjZU64oPGuq2VpUSTl7RYZO66XYwIqtWFUJF7RWR48wnuWaiVGpLf0NM8mU0j0rGhbVYHYxThQryDJK6y90X1M34klIBj84pviCFeVRQ8M_P2PUcWx3PGo7NP6CCoUwZxmVJbyd6VWLhR_UQCOzMF5REEZhLnZ6kPa1CJujlyptWHO8KUuQww1T6-05VHvsahnnHUoOxVTfSuQKnpDzE7tSe-ey7zD_j8dpzqnsM8U4zCW-0g9XzBdl2hGub7zHhHK4TcWh5G4Iuq0aA8OQoTlGgTMVDRUN2ovgyqD-jCmVDOGRpQcsZyRsS9TQp5VCp54HhsPSqL7zmqKS7A9co1QXNkXnrnfMS43_KLjetg9svRVpZsyN0f3IzrbTU6hD7vTWFnr5M2NoLIZNQb5gLeEfBE1hJmQiDmgNkjHnJlbHz6xj_buk85nNbQ-y86dQ6HiLfAML6joVuiXjqMXqePwHIKgmJQkIAAA=">Apr 6</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VVUW_aMBD-Kyc_U5EQkgFvFNZOBbqprfqCeLgRC7wltuQYtrbiv88JIVyIMzYpD8nZ_nzfd99dPlhsMjZiQTfwuj2vF8EN9Lth8co6LN1oNvpgYykRZkJu2Gi5ZMNR4MF4YXdGI8-Dbwu26iztQxaC-oLv59_FyqfaymrVYQ-Y8gyedlnGkwQedHFHiWwPlEdZiRNUOMEJh_WO7xeb-06IIUGoMiHRoTM6OEVtvgueoHyDL1xLlDF_z_Ot7_bbZAnr5I_8JxZNSVgoJfnbCSx0Uaoe5nsVuR4hFzYp2wumgm8UTDnMEe52XBoOr5ZDtlblbWfc8BqsRxisDh0mZJYbZIHGbPkvmGhhjC1jUcP-mQM51hKuV2zgEupFaQFfJSb4A8-Zt2VXwxue3XJhDY9W1rIQHKYqtVbfVZX9d3lINMebc2UQpiLjugHlVypQHxKDRyTlXOl4X7TiKyZcC4RnkeyxlPk6_1oBjh_FJX0SbtUxpzLeZUZImGr8ydsbtFkRIlPklKnVtfcapYEXlPKoHk07dLOJGq65XA9cx0JigVuORovfcIvaFO1Bshu6xWrQPxt8ULNdoeNe71L4nNzMtpht8fup30lT-CTLtmvIyGsO1Gcl7Xx6FOutSjLSKO66_3WlSFmnds4pO6HFu7Pt3LpcjZbwM4y5hPtE7WmX5J3gh45q-2SYBjTsOcKkAXx38XxS-0fFE5goHas91vq1rZECd7htXP7PJL4Y8iXrE441j9zAnLtOuW93hvPiihgl3Amz3jpToD9up9yV_VaHwx9AAcryTQgAAA==">Mar 30</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_51V32_aMBD-V05-plp-EAq8Udg6FeimtuoL4sErFvEWbMkxbF3F_z4nIfEZHGgn5SH6zrnc99135zey0jkZkvhTZJ4g6sEVmJdB-U46ZLNWZPhGRkJQmHKxJsPFggyGcQCjuTmaDIMAvs_JsrMgverdoGGAYHs4tqgbSC4Glh0y4WwtYcJgRuHLlgnN4JllNH-RZU2J_XvxNqprik_RIuA_nngpFI8p4I5uWA4P2zxnWQZ36iBFcKg1xIla4MhXTtvhSyVGCI0btI8kmxt9xCt8ZUpQsWJ_i4pdgcM25cPoPc1a7juEi7xwyJNUHL4JmtGftFTG2mFQsa6lrBJ2GykGyCz-Bhh69eHrOpehNzbkpIC5lIK91txqCcuzDgWTsebQQ7kRjN0chl6hPU0phKZap-w3jBXX2rjjUEzF0y8DCvTdQNQEeojsjElNYcJzpmx2t6LBEd-wIYaVOJTLGUzkxkz0tvHFf4wGhpFMpTFWu3J13CoqNDxRIarKSfX9qeAW7jlEWvzdeU8mvEBG21xzARNFf7EzK6OtYe6Kw2RbbXHDqFb8D9xQpastZY181HRvLW45VT-dlfRMM6Y4hUee7aqp6_rb9DG4tRWOOI6lRju13cDn7Gqa0jylP-pxbOXlF9_2-fqE7JSumIDbTO6aEcAe754M73k49sEJgtF95m6A2Gpm5_NRCrNq7_lLKrMczb_fo0eRrhMp9VQbs7KluW44Gk__sH8EPaS_lyyDsVQrWfkG7-UWp9h1HXt-0bYUGvjiDY5vh3ObxRghpWINM-b7KrTbs-_vfLMLl_v9PzOK6av-CAAA">Mar 23</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_6VV204bMRD9lZGft8reWMK-AatSQUIRIF6iPEzZUXC7sSXvJi1F-fd67zZxUFAlP3iP7TkzZy77xvKqZCmLJkEyCf0wgS8QTcKw2TOPrVeKpW_sXAiEGy5WLF0sWJL6PtzN9dWg3p3P2dJb6MXO0qj-7A_u-oNuLT12jWsq4X5TllQUcK0ae-Ozk_EZO3GxsHhAT427o4XpHrFmnVOB4hW-kRIocvpbs9rPTOKg47Nhy2DGaSUhI5ghfN2QqAieNEf5LDvTnSDuGEY0dKKB_7EM2oF7-YNUBY88_62FtEj3cpEYQSx3Hsu3bU43ZcUFZAp_UZMGp7NHBvKuENxOXykU2mcUgj5KfBu-Q3_zxAiKRQPbmZ0vzfmEBSmO8MCLLTaksVvnT8HH5cuEEwes3bsgrBT_AxeoqqZ2WOgK5rP6x7Ww7UHQbg1JHqTQzXDLn19kUY6lY6obH9Q93lP4VlIBl1LlshW4exMNLkxtD2x7ZhcHY-xTQ6MbzEnAVSG3bdkYdgYOy4zZv5EhoUsTE_Z7uCZ9QbGCGdmEB4skcsFWPCOjq4qPnymWhO-HSNPfXJR1f1_qkScFzKUU9NpPvPj46jo4RA5wuy7rsGYkK4SMl2byjJY1BrZVM1Y-HdPdTPOpUWH1uMeq4gSZXOs_1mYY9_81ky2RPfYoFYfvAgv8iY707BVWr8du9w84uL2JcgcAAA==">Mar 16</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VV32_aMBD-V05-TkUgJC15o7B1KtBNa9UXxINbLPAWbMkxbF3F_z7nF3bIeXRSH-jd-e6-7-67vJO1zklKot6oNwgHCVxB1OvH5W8SkN1GkfSdjIWgMONiQ9LlkozSKITxwoQmaRjCtwVZBUvz5ziitmNY_WscNxdfrAIy5WwjYcpgTuHzngnN4JllNH-VZf24eFRm6xePxmU2Yw0_ai0c1yfHoOUo6t_THcvh-z7PWZbBvapRh3WrfbxAAy3whSLmgAxO75MKFqkIwyBaGq8v1YoxeE6CU6yBuzDcijf4wpSgYs3-FHDbw-n7phZbx39Zm15d8-oYEC7yYt-epOLwVdCM_qAl-YltPGz3EnlWy05zYsBJAQspBXtrsJk0SF8Vcwj1tucOp8iGFZxSrbfsF0wU19psUVPXRo-wdquO50xqClOeM1W_q1sYdBbgDIu7Qw7HTnTTHGcwlTsj6f1p4LYOKg4XqauZYm7rQ3knnmnGFKfwyLNDNbghOrjL5jY7nvgazp2iQsMTFaLii1QxyHBrtsLu-fKw5Y1GzKaT8T7XXMBU0Z-sPlXYUbLqvrHz8t-wBJuGf_VmdM0E3GXyUNMRncqNXAh2mWJ8a7xmjwDdmRVkHNR-B5-yq9mW5lv64kgPoxTHHqXDuMle_iJtHbQJLMreMqoV_w23VGnZ1Eyw5F3Bdz8Fj1KY0_jAX7cyy61OXBDDNh9eT8mJ2pkTK823hTuqw6_CP2-FyfUgWQYTqday0lp3KVxp2SXwmPHKZ_Ls5rj4uT67b94rYhZ3S8UG5gx75ZMnYl4dj38Bdk_IMNYIAAA=">Mar 9</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VVTW_iMBD9KyOfqUhiPnOjZdtVge6qrXpBHLzEAm-DLdkBbVvx39dJIBkTp92VcgjPzny892b4IElmSExoN-pGQTSAK6DdUfFKOmS30ST-IBMpGcyE3JB4uSTjmAYwWdib_TgI4OeCrDpL-6ADWh-QQflu0TBAMK3gkRslDPPfbvxVh0wF3yiYcpgzuN1zmXF44Skza1UUhbKUnxdJhl7Uezc_6FcHEbpeoyGC85ru2Y4beNwbw9MU7nVRSc_XWBsLUU5ZAQ_LtwLtVSguuw48RBFqlHrvVhFsvQtLmHyD71xLJhP-ntfrChe2KVq2fsrpdcCXKEVqThK2gwU3RqxfT1VUz3_KcOyQ5FDadG8yIWGq2SsvpOh75feiF6SFXuki977HR7a1O81kBs9MSl4aohTcMzDtBkAzMHQ_sQleWMq1YPAk0gM7WY76zIX6-QcYldlzXdD3f-CDbXnXnGVa_IFrprNyNlE3Pa_Lxw1a-nVHLumFeQ56v4Nv6dVsy8yW_Trb2E90iwtal8DZ6Rfc27wzlnAJd6k6lMpe3Ma91bJebDeKDqivxNCpnDZgW8eTknaKH8R6q1JTT88nCraeFHTqnd0Gyu4x8Y6i1TWNvWR-iZ7CPyiewo3SiSrd6ow69fGE-w7wVCDD0IoNawK5gTm_jO3-ybhWr0UbIV4nImESbkW23vqCIRIH_rmp4HwpCWnypXRjN66SsFBK8jfkVNoM1TihOIlvuZ5t4W7_vJdnpQX8kCxlv5kjaoPC8-77XIixM7jewZ9zlTGYClNNR2OvjtykLTSsjse_Ead48pcIAAA=">Mar 2</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VVTW_bMAz9K4LOKRLJcT58S5u1Q5N0RVv0UuSgxUKszZEw2QnWFvnvk_wp1XSAAT4IFPVIvkfSnzjOMxxhOqTBkI7oBF2hYEiKIx7gw17j6BMvpGRoJeQeR29veBKNRuhxYzyJPS02eDvwrKPyWJjnUWBdaufHi87jxjyzz0qr_bYDfM8OPENPxyzjaYrudZEKqTIwL2iFM8BhgzJtUXAAWuFawDw8BChnCiI0uKaGDU-ZfEffuZZMxvzD1tBLkn8RgpzCVnrZ1ySyFHyv0JKjNUO3Ry5zjl5NbtlO1SnNIGJ6L_AUFLSW7pjlQpqypRZ_jjyrYth3hJYEdyR3VHR5pXDjkAZlXqNszwMsZGbb98aQriTaKCX5e9E3MIMlZGEe-0U0n6nmRWmBfkiWsl_s6zz4tTs1zP0LArVShb_mKmdoKTKuazECpx99nLb_p34hdX0T1wx6F0zFp2LQX1nKtWDoWaSnsrgxTDhs_kJi2MeG98aUfKeZzNELk5JXc-0qEUACebpRh86gh5-wQ_SibMulZr95EdVJEF5s3iT4d9S7g6BMxBWLuUR3qTrxzv4KIxJ6HWdUH4cg9Z1e9wZj5nN7zVmuxV90zXTeTHcvY34AQjpr-FlJs8EexC5RqTfIfbNzYaqsBid9PKBv6dUqYVnCfjqIkzYNRw1YI3g1w-rYqPpg9q8yfxPx4UQEx_V_rBX8g-IpulE6VuUQNXpCwhEQPoDWojN1c68hOlbbawmTe7TmbQKtwo4k3n5ozU1XWLZEzCS6FfkuAcF6dhBpdlALdj7_AwZ7zUZxCAAA">Feb 23</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VVTW_aQBD9K6M9E4ENNh83EppEfKRVEuWCOEzxCm9rdtW1QU2j_PcuNrbH7i5pJB_M7PJm3ps34zcWZSmbML_rhV2_54dwBX7X9_N31mHRUbPJG3vBhGuB8CSSI7LJes0Gk14Pvq3Mda9XvLJNZ20exwkrfkxP8QEJB_bbnwhvOuxOo8zgGaXkOq_OkYyEAxLuV6ijSb-K1jzGDYKnx-ScHtJMSJhp_MnznKS2Iku74jraTDomScMq6jevW3BMEQuMuIS7RB0L4jlJ74SXkxzWyGcYz6sUGBIFHN00Ga45Zlr8hmvUmSpTDArcVu1Oqr5LSYP_pKR8hQexjVWSnvHdrbp4kndF71FGCh4P4g9BC2wVfCZawh_1YQ9fkqtFjGmM3-sUFwWwd9XgPSiewI3SkSrGqnZYQ2VD2ebLxmhY7HoySIxyB0veBm8JGdqHJCRIUxGhhFuRbWMrmNV1Vr9t3jtsv8v3ylRKhIWQu3yCQpt-NEr5jqt8Xssftd1G_zRwjnueGnekKU8SmBfbYkxKJzr4lf4lo84ZfNqukdwdXe5Jo6_EDaSIkZVlWKpqWKx4gmZq7rmWxu28dLpbE3Lg25bZvFhm91xq8evAy0F0O5q0O3SUa93a9r6SjTYTfKdgxmGJcHvgMuPwYtimW0XGeWQFtEZLjsZzQqYnz90Y6ZSElVKSv7b6H3zExU3SCnKW91lpAV8lJvgD205vfT0DOvSNk3594lGb_v9GN5UsucoQZiI9fyjrWQmtf6ZerO8OXZV9aH7TiPe_wg-FZ3QIAAA=">Feb 16</a>&ensp;
                    <a href="https://www.canmoo.me/dpz/viz?data=H4sIAAAAAAAA_5VVTU_jMBD9KyOfg5qkH2xyq-jCilJAgLhUPRhipWbdsXCaShT1v6-d0MRJbdBKOTgzzsyb92YmnyTbFiQl8SAZxGE8gTOIB9G4OpOAbHJF0k8yRaQw55iTdLkkkzQM4X6hr0bmNF2QVbDUD0nSoXk9Ou4rh309tMxR3Nh_tWbzrAJyTTesgIeyKJgQcK2qvG34pBtneBqHjF0gyai5m9Qn0sU9cVpjK0JrHR-zabwLJih-wB-mkGLG9gavl5GeI-5WXxMw4yyXMGNwQ-GyZLhl8KxzFK_yGPq8KaWngtOhrS4VjnSXxZajho-Kv5es-MpxQm9LThQ1BZxb5nFzOe6CGp2CWh0Cku2q_rpSFLfwRBFZLXWNsUtz4DMbz7ApzxbWyhqdFD2ti54p-pdVSd0t47a2-XqRrXbvUeAYG43imQqmOIVHLna0gjGySgmtUjz62aSM3APQ-8Dl0UjmNGMIV0LuahH8Mn_XF-1U230Ru2oySR8l6rm55a9rKTpt51Xa66k03alyA7_F2XxNizV9sSL-j7ot2fZKcStrsqqNnnqp9xXfOzMmTl1-tH6Fv5VMwIVUmaw7pF0Uga9bLJImXcI1MZjDDesH8q9kZzCzNOQa4UFmiucl27vieVrQDD7Hwgz-k1Qc7pAK-kZ7M9j9KVibpT9wkRt05GLANtv7-0Jvb4mwkBLZRwVk6KPC8avwe2wKon5Bjik8HP4BNTvTKZEHAAA=">Feb 9</a>&ensp;
                </p>
                <h3>{obj["dts"]}</h3>
                <p>Store #9285</p>
                <Tabbed
                    tabs={tabNames}
                    items={tabContent}
                />
            </>}
    />

}